import React from 'react';
import { FollowUs } from '@shared/ui/follow-us';
import { MoreAboutTheCompany } from '@shared/ui/more-about-the-company';

export const CheckMarkLYFooter = () => (
  <>
    <FollowUs />
    <MoreAboutTheCompany />
  </>
);
